import { useTranslation } from "react-i18next";
import classNames from "classnames";
import styles from "./styles.module.scss";

type Props = {
  feeAmount?: number;
  remainingShippingFeeAmount: number;
};

const WaffyFeesSummary = ({
  feeAmount = 0,
  remainingShippingFeeAmount,
}: Props) => {
  const { t } = useTranslation();

  return (
    <div className={styles.waffy_fees_container}>
      <div className={styles.waffy_fees_item}>
        <div className={styles.waffy_fees_item_content}>
          <p className={classNames(styles["g600"], styles["subtitle2"])}>
            {t("lbl_waffy_fees_amount")}
          </p>

          <h2 className={classNames(styles["g700"], styles["h2"])}>
            {`${feeAmount.toFixed(2)} ${t("lbl_saudi_currency")}`}
          </h2>
        </div>
      </div>

      <div className={styles.waffy_fees_item}>
        <div className={styles.waffy_fees_item_content}>
          <p className={classNames(styles["g600"], styles["subtitle2"])}>
            {t("lbl_remaining_shipping_fee")}
          </p>

          <h2 className={classNames(styles["g700"], styles["h2"])}>
            {`${remainingShippingFeeAmount.toFixed(2)} ${t(
              "lbl_saudi_currency"
            )}`}
          </h2>
        </div>
      </div>

      <div className={styles.waffy_fees_item}>
        <div className={styles.waffy_fees_item_content}>
          <p className={classNames(styles["g600"], styles["subtitle2"])}>
            {t("lbl_your_profit")}
          </p>

          <h2 className={classNames(styles["profitText"], styles["h2"])}>
            {`${(feeAmount + remainingShippingFeeAmount).toFixed(2)} ${t(
              "lbl_saudi_currency"
            )}`}
          </h2>
        </div>
      </div>
    </div>
  );
};

export default WaffyFeesSummary;
